import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import { formUrl } from '../../../utils/url';

import styles from './AboutUs.scss';

const AboutUs = ({
    description, website,
}) => (
    <>
        <div className={styles.header}>
            <h2 className={styles.sectionHeadline}>About Us</h2>
            {website && (
                <a
                    href={formUrl(website)}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.webLink}
                >
                    <span><FontAwesomeIcon icon={faGlobe} /></span>
                    Visit Our Website
                </a>
            )}
        </div>
        <p className={styles.description}>{description}</p>
    </>
);

AboutUs.propTypes = {
    description: PropTypes.string,
    website: PropTypes.string,
};

AboutUs.defaultProps = {
    description: '',
    website: '',
};

export default AboutUs;
